import styles from '../styles.module.scss';

export const DevicesGetSeasonData = ({ id, fields }) => {
  if (!fields.length || !id) {
    return;
  }
  let data = null;
  fields.map((field) => {
    if (!data && field.seasons.length) {
      const season = field.seasons.filter((item) => item.id === id);
      if (season.length) {
        data = { season: season[0], field: field.name };
      }
    }
  });

  return data;
};

export const GetShortId = (id) => {
  return id ? `(${id.slice(0, 5)}-${id.slice(5, 11).replace('-', '')})` : null;
};

export const GetFormatedSerialNumber10 = (value) => {
  if (!value || value.length < 10) return null;
  return value.replace(/-/g, '').slice(0, 10);
};

export const GetDevicesLocationsColumns = (t) => [
  {
    title: t('labels.name'),
    dataIndex: 'name',
    key: 'name',
    className: styles.locationsTableColumn,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: t('labels.field'),
    dataIndex: 'field',
    key: 'field',
    className: styles.locationsTableColumn,
  },
  {
    title: t('labels.crop'),
    dataIndex: 'crop',
    key: 'crop',
    className: styles.locationsTableColumn,
  },
  {
    title: t('labels.varietyHybrid'),
    dataIndex: 'variety',
    key: 'variety',
    className: styles.locationsTableColumn,
  },
  {
    title: t('labels.installedRemoved'),
    dataIndex: 'period',
    key: 'period',
    className: styles.locationsTableColumn,
  },
  {
    title: ' ',
    dataIndex: 'operation',
    key: 'operation',
    align: 'right',
    className: styles.locationsTableColumn,
  },
];

export const GetDevicesAddFormSteps = (t) => ({
  add: {
    title: t('devices.steps.add'),
    step: 0,
    stepLine: 1,
  },
  turnOn: {
    title: t('devices.steps.turnOn'),
    step: 1,
    stepLine: 2,
  },
  connecting: {
    title: t('devices.steps.connecting'),
    step: 2,
    stepLine: 2,
  },
  error: {
    title: t('devices.steps.error'),
    step: 3,
    stepLine: 2,
  },
  success: {
    title: t('devices.steps.success'),
    step: 4,
    stepLine: 3,
  },
});
export const GetDevicesAddFormStepsQRCode = (t) => ({
  add: {
    title: t('devices.steps.add'),
    step: 0,
    stepLine: 1,
  },
  workspaces: {
    title: t('devices.steps.workspace'),
    step: 1,
    stepLine: 2,
  },
  turnOn: {
    title: t('devices.steps.turnOn'),
    step: 2,
    stepLine: 3,
  },
  connecting: {
    title: t('devices.steps.connecting'),
    step: 3,
    stepLine: 3,
  },
  error: {
    title: t('devices.steps.error'),
    step: 4,
    stepLine: 3,
  },
  success: {
    title: t('devices.steps.success'),
    step: 5,
    stepLine: 4,
  },
});